/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { HttpClient, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { InjectionToken, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { RouteReuseStrategy } from '@angular/router'
import { IonApp, IonContent, IonHeader, IonIcon, IonicRouteStrategy, IonMenu, IonMenuToggle, IonRouterOutlet, IonSplitPane, provideIonicAngular } from '@ionic/angular/standalone'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { ApiServiceBase, IApiConfig, ModelMiscModule } from '@sightline/models-misc'
import { CommonsModule } from '../../src/commons/commons.module'
import { environment } from '../../src/environments/environment'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics'
import { MaterialModule } from './material/material.module'
import { LanguageTranslationService } from '../../src/commons/services/ui/languageTranslation.service'
import { OKTA_CONFIG } from '../../src/security/models/services/auth'
import { UserApiService } from '../../src/security/models/services/users/userApi.service'
import { SecurityModule } from '../../src/security/security.module'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { FaIconLibrary } from '@fortawesome/angular-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'

const API_CONFIG = new InjectionToken<IApiConfig>('ApiConfig')
@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    SecurityModule,
    ModelMiscModule,
    MaterialModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    CommonsModule,
    NgxGoogleAnalyticsModule.forRoot(environment.measurementId),
    NgxGoogleAnalyticsRouterModule,
    IonApp,
    IonSplitPane,
    IonIcon,
    IonContent,
    IonHeader,
    IonRouterOutlet,
    IonMenu,
    IonMenuToggle
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    {
      provide: UserApiService,
      deps: [ApiServiceBase, API_CONFIG],
    },
    ApiServiceBase,
    {
      provide: API_CONFIG,
      useValue: {
        url: environment.apiUrl,
        version: environment.apiVersion,
      },
    },
    {
      provide: OKTA_CONFIG,
      useFactory: () => {
        return {
          clientId: environment.clientId,
          issuer: environment.issuer,
          scopes: environment.scopes,
          pkce: environment.pkce,
        }
      },
    },
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideIonicAngular()
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(translateService: LanguageTranslationService,
    library: FaIconLibrary
  ) {
    translateService.setLang()
    library.addIconPacks(fas)
    registerAllIcons()
  }
}

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './app/i18n/', '.json')
}

import { addIcons } from 'ionicons'
import * as allIcons from 'ionicons/icons'

export function registerAllIcons() {
  addIcons(allIcons)
}
